// CapaType Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { capaTypeConfig } from './capaTypeConfig';
import { createCapaTypeValidation } from './capaTypeValidation';
// CapaTypeService no longer needed - using SWR hooks directly

/**
 * Initialize the capaType module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  capaTypeConfig,
  createCapaTypeValidation
);

/**
 * Create the CapaTypePage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const CapaTypePage = createModulePage(
  initializedConfig,
  {
    displayName: 'CapaTypePage',
    description: 'CAPA Type Management System - Manage CAPA types for corrective and preventive action classification'
  }
);

export default CapaTypePage;
